export default __webpack_public_path__ + "static/media/medicine.c5c94d8f.png";